// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__v19kL","header":"ClearentDisclaimer_header__1Fxcf","inner":"ClearentDisclaimer_inner__3eNbV"};